import React, {
    useState,
    // useEffect,
} from 'react';
import { Helmet } from 'react-helmet';
import GlobalStyle from 'stylecomponents/globalstyle';

/**
 * Call WebATM ( 國泰世華WebATM拿掉，此元件暫無作用 )
 * @author Ac
 * @time 2020 / 04 / 21
 */
const WebATMPayerView = () => {

    const [isError, /*setIsError*/] = useState(false);

    // const init = () => {

    //     const checkoutstruct = JSON.parse(sessionStorage.getItem('checkoutstruct'));

    //     if (!checkoutstruct) {
    //         setIsError(true);
    //     } else {

    //         sessionStorage.removeItem('checkoutstruct');

    //         const {
    //             CathyWebATMURL,
    //             CompanyID,
    //             orderNoGenDate,
    //             ItemNo = '',
    //             PtrAcno,
    //             PurQuantity,
    //             amount,
    //             AuthCode,
    //             MerchantKey,
    //         } = checkoutstruct;

    //         const form = document.createElement('form');
    //         form.setAttribute('name', 'cathyatmcfm');
    //         form.setAttribute('action', CathyWebATMURL);
    //         form.setAttribute('method', 'POST');
    //         form.setAttribute('accept-charset', 'big5');

    //         const formData = [
    //             { name: 'CompanyID', value: CompanyID },
    //             { name: 'orderNoGenDate', value: orderNoGenDate },
    //             { name: 'ItemNo', value: ItemNo },
    //             { name: 'PtrAcno', value: PtrAcno },
    //             { name: 'PurQuantity', value: PurQuantity },
    //             { name: 'amount', value: amount },
    //             { name: 'AuthCode', value: AuthCode },
    //             { name: 'MerchantKey', value: MerchantKey },
    //         ];

    //         formData.forEach(data => {
    //             const input = document.createElement('input');
    //             input.setAttribute('type', 'hidden');
    //             input.setAttribute('name', data.name);
    //             input.setAttribute('value', data.value);
    //             form.appendChild(input);
    //         });

    //         document.body.appendChild(form);
    //         form.submit();
    //     }
    // };

    // useEffect(() => {
    //     init();
    //     return () => {
    //         sessionStorage.removeItem('checkoutstruct');
    //     }
    // }, []);

    if (isError) {
        return (
            <GlobalStyle.SubContainer>
                <GlobalStyle.BasicBlock>
                    <GlobalStyle.ErrorContainer>
                        <GlobalStyle.ErrorContainerTitle>連結已失效</GlobalStyle.ErrorContainerTitle>
                        <GlobalStyle.ErrorContainerDesription>請重新按正常流程連結WebATM付款</GlobalStyle.ErrorContainerDesription>
                    </GlobalStyle.ErrorContainer>
                </GlobalStyle.BasicBlock>
            </GlobalStyle.SubContainer>
        );
    }

    return (
        <Helmet>
            <meta name='referrer' content='no-referrer-when-downgrade' />
        </Helmet>
    );
};

/*--------------------------
    Export
--------------------------*/
export default WebATMPayerView;
